(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-siblings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('color-siblings')) {
    class ColorSiblings extends HTMLElement {
      connectedCallback() {
        if (this.dataset.hoverPreview !== 'true') return;
        const card = this.closest('product-card');
        if (!card) return;
        const labelEl = this.querySelector('[data-cs-label]');
        const originalLabel = labelEl ? labelEl.textContent : null;
        let img = null;
        let original = null;

        const getImg = () => {
          if (img && img.isConnected) return img;
          img = card.querySelector('.product-card__content img:not(.color-siblings__img)');
          return img;
        };

        const show = (swatch) => {
          const target = getImg();
          if (labelEl && swatch.dataset.csName) labelEl.textContent = swatch.dataset.csName;
          if (!target || !swatch.dataset.csSrc) return;
          if (!original) original = { src: target.getAttribute('src'), srcset: target.getAttribute('srcset') };
          target.setAttribute('srcset', swatch.dataset.csSrcset || '');
          target.setAttribute('src', swatch.dataset.csSrc);
        };

        const reset = () => {
          if (labelEl && originalLabel !== null) labelEl.textContent = originalLabel;
          const target = getImg();
          if (!target || !original) return;
          if (original.srcset) target.setAttribute('srcset', original.srcset); else target.removeAttribute('srcset');
          if (original.src) target.setAttribute('src', original.src);
        };

        this.querySelectorAll('.color-siblings__swatch').forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => show(swatch));
          swatch.addEventListener('focus', () => show(swatch));
        });
        this.addEventListener('mouseleave', reset);
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) reset(); });
      }
    }
    customElements.define('color-siblings', ColorSiblings);
  }
  } catch(e) { console.error(e); }
})();

})();
